import React from 'react';
import { Sk } from '../../../../components/Skeleton';

function CardSkeleton() {
    return (
        <article className="bg-white border border-[#EDEFF3] rounded-[12px] p-[20px]">
            <div className="flex items-start justify-between gap-[12px] mb-[12px]">
                <div className="flex items-center gap-[10px] flex-wrap">
                    <Sk w={56} h={16} />
                    <Sk w={120} h={12} />
                </div>
                <Sk w={64} h={24} r="rounded-full" />
            </div>
            <div className="space-y-[8px] mb-[12px]">
                <Sk w="92%" h={14} />
                <Sk w="78%" h={14} />
            </div>
            <div className="space-y-[6px]">
                <Sk h={10} />
                <Sk w="96%" h={10} />
                <Sk w="82%" h={10} />
            </div>
        </article>
    );
}

function GroupSkeleton({ cardCount = 3 }) {
    return (
        <div className="flex flex-col gap-[12px]">
            <Sk w={96} h={12} className="my-[4px]" />
            <div className="space-y-[12px]">
                {Array.from({ length: cardCount }).map((_, i) => (
                    <CardSkeleton key={i} />
                ))}
            </div>
        </div>
    );
}

export function InsightsListSkeleton({ groups = 2 }) {
    return (
        <div className="relative overflow-hidden">
            <div className="flex flex-col gap-[28px]">
                {Array.from({ length: groups }).map((_, i) => (
                    <GroupSkeleton key={i} cardCount={i === 0 ? 3 : 2} />
                ))}
            </div>
            <div
                className="absolute bottom-0 left-0 right-0 h-40 pointer-events-none"
                style={{ background: 'linear-gradient(to top, #FAFAFA 10%, transparent 100%)' }}
            />
        </div>
    );
}

export function InsightDetailSkeleton() {
    return (
        <div className="relative overflow-hidden">
            <div className="flex flex-col gap-[20px]">
                <div className="space-y-[10px]">
                    <Sk w="72%" h={26} />
                    <Sk w="88%" h={26} />
                </div>

                <div className="bg-white border border-[#EDEFF3] rounded-[12px] p-[20px] space-y-[10px]">
                    <Sk h={12} />
                    <Sk w="96%" h={12} />
                    <Sk w="92%" h={12} />
                    <Sk w="84%" h={12} />
                    <Sk w="60%" h={12} />
                </div>

                <div className="bg-white border border-[#EDEFF3] rounded-[12px] p-[20px] space-y-[10px]">
                    <Sk w={140} h={16} className="mb-[6px]" />
                    <Sk w="98%" h={12} />
                    <Sk w="90%" h={12} />
                    <Sk w="86%" h={12} />
                </div>

                <div className="bg-white border border-[#EDEFF3] rounded-[12px] p-[20px] space-y-[10px]">
                    <Sk w={120} h={16} className="mb-[6px]" />
                    <Sk w="94%" h={12} />
                    <Sk w="72%" h={12} />
                </div>
            </div>
            <div
                className="absolute bottom-0 left-0 right-0 h-40 pointer-events-none"
                style={{ background: 'linear-gradient(to top, #FAFAFA 10%, transparent 100%)' }}
            />
        </div>
    );
}
